import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { FactureFormdata, IFacture } from './facture.type';
import { QueryUrl, useLocationState } from '../../Utils';


const FactureApi = createApi({
    reducerPath: "factureApi",
    tagTypes: ["factures"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        addFacture: build.mutation<IFacture, { slug?: string; data: IFacture }>({
            query: ({ slug, data }) => ({
                url: slug ? `factures/${slug}/` : `factures/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["factures"],
        }),
        getFactures: build.query<PaginationResults<IFacture>, TypeQuery>({
            query: ({ slug, ...query }) => QueryUrl(`factures/`, query),
            providesTags: ["factures"],
        }),
        deleteFacture: build.mutation<FactureFormdata, string>({
            query: (slug) => ({
                url: `factures/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["factures"],
        }),
        downloadInvoice: build.query<any, TypeQuery>({
            query: (query) => ({
                url: QueryUrl("admin/download/multiple/facture/", query),
                method: 'GET',
                responseHandler: (response) => response.blob(),
                cache: 'no-cache',

            }),
            async onQueryStarted(query, { queryFulfilled }) {
                try {
                    const { data: blob } = await queryFulfilled;

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${query?.word || 'Factures'}.zip`;
                    document.body.appendChild(a);
                    a.click();

                    a.remove();
                    window.URL.revokeObjectURL(url);
                } catch (err) {
                    console.error('Erreur téléchargement', err);
                }
            },
        })
    }),
});

export default FactureApi

export const {
    useAddFactureMutation,
    useGetFacturesQuery,
    useDeleteFactureMutation,
    useLazyDownloadInvoiceQuery
} = FactureApi;